import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  age: number;
  country: string;
  text: string;
  avatar: string;
}
export function Testimonials() {
  const testimonials: Testimonial[] = [{
    name: 'Martín González',
    age: 28,
    country: 'Buenos Aires, Argentina',
    text: 'Llevaba años postergando mis proyectos personales. Este sistema me ayudó a entender que no necesitaba motivación, sino un plan claro. En 3 semanas ya tenía hábitos que antes me parecían imposibles.',
    avatar: 'https://i.pravatar.cc/150?img=12'
  }, {
    name: 'Ana Sofía Ramírez',
    age: 32,
    country: 'Ciudad de México, México',
    text: 'Lo intenté todo antes: apps, cursos, videos motivacionales. Nada funcionaba hasta que encontré este método. Simple, directo y funciona incluso cuando no tengo ganas. Cambió mi vida completamente.',
    avatar: 'https://i.pravatar.cc/150?img=45'
  }, {
    name: 'Carlos Mendoza',
    age: 25,
    country: 'Bogotá, Colombia',
    text: 'Siempre empezaba con mucha energía y abandonaba a los pocos días. Este sistema me enseñó a construir disciplina real, no depender de la motivación. Ahora cumplo lo que me propongo.',
    avatar: 'https://i.pravatar.cc/150?img=33'
  }, {
    name: 'Laura Fernández',
    age: 35,
    country: 'Madrid, España',
    text: 'Me costaba mantener la constancia en cualquier cosa que empezaba. Los dos ebooks me dieron las herramientas exactas que necesitaba. Primero eliminé la procrastinación, después construí hábitos sólidos.',
    avatar: 'https://i.pravatar.cc/150?img=47'
  }, {
    name: 'Diego Vargas',
    age: 29,
    country: 'Santiago, Chile',
    text: 'Pensaba que el problema era yo, que no tenía fuerza de voluntad. Este método me mostró que solo necesitaba un sistema que funcionara. En 21 días mi vida cambió radicalmente.',
    avatar: 'https://i.pravatar.cc/150?img=15'
  }];
  return <section className="w-full bg-gray-100 py-20 md:py-32 px-4" data-id="element-145">
      <div className="max-w-6xl mx-auto" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-147">
          <h2 className="text-4xl md:text-6xl font-black text-center mb-16" data-id="element-148">
            Lo que dicen quienes ya lo aplicaron
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-149">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-white p-6 rounded-xl shadow-lg" data-id="element-150">
                <div className="flex gap-1 mb-4" data-id="element-151">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-152" />)}
                </div>

                <p className="text-gray-700 mb-6 italic" data-id="element-153">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center gap-3" data-id="element-154">
                  <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full" data-id="element-155" />
                  <div data-id="element-156">
                    <p className="font-bold" data-id="element-157">
                      {testimonial.name}, {testimonial.age}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-158">
                      {testimonial.country}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}